import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import { TirPmTooltipDirective } from "tir-pm-tooltip";
import "tir-pm-tooltip/src/style.scss";

import DefaultTheme from "tir-style-system/default-theme.scss";
import DarkTheme from "tir-style-system/dark-theme.scss";
import Variables from "tir-style-system/variables.scss";
import MainStyles from "@/style.scss";
import { CurrentUserService } from "./current-user";
import { fetchAppWebSettings, setFavicon } from "./settings-service";
import { initFileUploadManager } from "./file-upload-manager";
import { TirCropperVarsModel } from "tir-pm-cropper";
import {
  TirPmDatepickerStyleVars,
  TirPmResizablePanelStyleVars,
  TirPmSvgStyleVars,
  TirPmMenuLayoutStyleVars,
  TirPmSkeletonLoaderStyleVars,
  TirPmTooltipElementStyleVars,
} from "tir-components";

setFavicon()

const initDefaultTheme = () => DefaultTheme;
const initDarkTheme = () => DarkTheme;
const initVariables = () => Variables;
const initMainStyles = () => MainStyles;
TirCropperVarsModel.setVars(new TirCropperVarsModel());
TirPmDatepickerStyleVars.setVars(new TirPmDatepickerStyleVars());
TirPmSvgStyleVars.setVars(new TirPmSvgStyleVars());
TirPmResizablePanelStyleVars.setVars(new TirPmResizablePanelStyleVars());
TirPmMenuLayoutStyleVars.setVars(new TirPmMenuLayoutStyleVars());
TirPmSkeletonLoaderStyleVars.setVars(new TirPmSkeletonLoaderStyleVars());
TirPmTooltipElementStyleVars.setVars(new TirPmTooltipElementStyleVars());

await fetchAppWebSettings(`${location.host}/appWebSettings.json`);
initFileUploadManager();
await CurrentUserService.initCurrentUser();

const app = createApp(App);
app.directive("tooltip", TirPmTooltipDirective);
app.use(router);
app.mount("#app");
